export var figurePortalTokens = {
  size: "s",
  // Отступы для контейнера Figure
  pt: 12,
  pb: 24,
  figCaption: {
    // Отступы для подписи
    pt: 16,
    pb: 8,
    color: function color(_ref) {
      var _color = _ref.color;
      return _color.text.secondary.base;
    }
  }
};